import { Link } from 'react-router-dom';
import { articlesByCategory } from '@/mocks/articles';

export default function WorksSection() {
  const works = articlesByCategory('works').slice(0, 3);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50" aria-labelledby="works-title">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-10">
          <div>
            <p className="text-xs md:text-sm text-primary-500 font-medium tracking-widest mb-2">FEATURED WORKS</p>
            <h2 id="works-title" className="font-heading text-2xl md:text-3xl text-foreground-950">作品精选</h2>
          </div>
          <Link
            to="/category/works"
            className="flex items-center gap-1.5 text-sm text-secondary-600 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {works.map((work, idx) => (
            <Link
              key={work.slug}
              to={`/article/${work.slug}`}
              className={`group bg-background-100 rounded-lg overflow-hidden cursor-pointer ${
                idx === 0 ? 'lg:col-span-3 lg:flex lg:flex-row' : ''
              }`}
            >
              <div className={`${idx === 0 ? 'lg:w-1/2' : ''} overflow-hidden`}>
                <div className={`${idx === 0 ? 'lg:h-72' : 'h-48'} w-full overflow-hidden`}>
                  <img
                    src={work.image}
                    alt={work.title}
                    className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                    loading="lazy"
                  />
                </div>
              </div>
              <div className={`${idx === 0 ? 'lg:w-1/2' : ''} p-5`}>
                <span className="inline-block text-xs text-primary-500 font-medium bg-primary-50 px-2.5 py-0.5 rounded-full mb-3">
                  {work.tags[0]}
                </span>
                <h3 className="font-heading text-lg text-foreground-900 group-hover:text-primary-600 transition-colors mb-2">
                  {work.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed line-clamp-2">
                  {work.summary}
                </p>
                <p className="text-xs text-foreground-400 mt-4">{work.date}</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}